export default "/images/ic-brodcart.svg?fa6c4b0b9b96c86aad2c41cc234ed8c8";